import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";

const initialRoute = "enrollments";
const { get } = request;

export const getEnrollmentCurrentBenefitEmail = async (query: any) => {
	try {
		// console.log("query inside the api call", query);
		const token = localStorage.getItem("@jwt_member");
		const endpoint = `${initialRoute}/current-benefits`;
		const response = await get(
			endpoint,
			{
				...headers,
				Authorization: `Bearer ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
			throw new Error();
		}
		throw new Error();
	} catch (err: any) {
		// console.log("errr", err);
		// alert("Failed to add enrollment");
		throw err;
	}
};
